/**
 * UnsavedChangesModal Component
 * Custom modal to confirm navigation when there are unsaved changes
 */

import React from 'react';
import useBodyScrollLock from '../../../../hooks/useBodyScrollLock';
import './UnsavedChangesModal.scss';

const UnsavedChangesModal = ({ isOpen, onCancel, onConfirm, changesCount }) => {
  // Lock body scroll when modal is open
  useBodyScrollLock(isOpen, ['.unsaved-changes-modal', '.unsaved-changes-modal-overlay']);

  if (!isOpen) return null;

  return (
    <div className="unsaved-changes-modal-overlay" onClick={onCancel}>
      <div className="unsaved-changes-modal" onClick={(e) => e.stopPropagation()}>
        <div className="unsaved-changes-modal__header">
          <div className="warning-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="22" fill="#fa8c16" fillOpacity="0.1"/>
              <circle cx="24" cy="24" r="18" fill="#fa8c16" fillOpacity="0.15"/>
              <path d="M24 16V26M24 30V32" stroke="#fa8c16" strokeWidth="3" strokeLinecap="round"/>
            </svg>
          </div>
          <h2>Unsaved Changes</h2>
        </div>

        <div className="unsaved-changes-modal__body">
          <p className="main-message">
            You have <strong>{changesCount}</strong> unsaved change{changesCount !== 1 ? 's' : ''}.
          </p>
          <p className="sub-message">
            Are you sure you want to leave? Your changes will be lost.
          </p>
        </div>

        <div className="unsaved-changes-modal__footer">
          <button 
            className="btn-cancel" 
            onClick={onCancel}
            autoFocus
          >
            Stay on Page
          </button>
          <button 
            className="btn-confirm" 
            onClick={onConfirm}
          >
            Leave Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;

